import { fromJS } from 'immutable'
import { Actions } from './auth.actions'
import * as AuthTypes from './auth.types'

export const initialState = fromJS<any>({
  isAuthenticated: false,
  refresh: {
    isLoading: false,
  },
  login: {
    isLoading: false,
    twoFactorVerificationCodeSent: false,
    validityMs: null,
    validationErrors: {},
    data: {
      email: '',
      password: '',
    },
  },
  requestPasswordReset: {
    isLoading: false,
    isSucceed: false,
    validationErrors: {},
    data: {
      email: '',
    },
  },
  passwordReset: {
    isLoading: false,
    validationErrors: {},
    data: {
      email: '',
      password: '',
      passwordConfirm: '',
    },
  },
})

export function authReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case AuthTypes.LOGIN_REQUEST: {
      return state.setIn(['login', 'isLoading'], true)
    }

    case AuthTypes.LOGIN_SUCCESS: {
      return state
        .set('isAuthenticated', true)
        .setIn(['login', 'isLoading'], false)
        .setIn(['login', 'twoFactorVerificationCodeSent'], false)
    }

    case AuthTypes.LOGIN_FAILURE: {
      return state.setIn(['login', 'isLoading'], false)
    }

    case AuthTypes.LOGOUT_SUCCESS: {
      return state
        .set('isAuthenticated', false)
        .setIn(['login', 'validityMs'], null)
    }

    case AuthTypes.TWO_FACTO_VERIFICATION_CODE_SENT: {
      return state
        .setIn(['login', 'twoFactorVerificationCodeSent'], true)
        .setIn(['login', 'validityMs'], action.payload.validityMs)
        .setIn(['login', 'isLoading'], false)
    }

    case AuthTypes.REQUEST_PASSWORD_RESET_REQUEST: {
      return state.setIn(['requestPasswordReset', 'isLoading'], true)
    }

    case AuthTypes.REQUEST_PASSWORD_RESET_SUCCESS: {
      return state
        .setIn(['requestPasswordReset', 'isLoading'], false)
        .set('requestPasswordReset', initialState.get('requestPasswordReset'))
        .setIn(['requestPasswordReset', 'isSucceed'], true)
    }

    case AuthTypes.REQUEST_PASSWORD_RESET_FAILURE: {
      return state.setIn(['requestPasswordReset', 'isLoading'], false)
    }

    case AuthTypes.PASSWORD_RESET_REQUEST: {
      return state.setIn(['passwordReset', 'isLoading'], true)
    }

    case AuthTypes.PASSWORD_RESET_SUCCESS: {
      return state.setIn(['passwordReset', 'isLoading'], false)
    }

    case AuthTypes.PASSWORD_RESET_FAILURE: {
      return state.setIn(['passwordReset', 'isLoading'], false)
    }

    case AuthTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case AuthTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
